module.exports = __webpack_public_path__ + "img/info.8dd0623d.svg";